import { useTranslation } from 'react-i18next'

import { Check } from 'lucide-react'

const STEP_KEYS = ['1', '2'] as const
const BADGE_KEYS = ['1', '2', '3', '4'] as const

export function SeoKeywordPricesSection() {
    const { t } = useTranslation()

    return (
        <section className='bg-white px-[22px] py-12 md:px-10 md:py-16'>
            <div className='mx-auto flex w-full max-w-[720px] flex-col md:max-w-[900px]'>
                <div className='mb-2 flex flex-col gap-2'>
                    <div className='text-xs font-semibold uppercase tracking-[2px] text-[#F4502A]'>
                        {t('seoKeyword.shared.prices.eyebrow', 'De dónde salen los precios')}
                    </div>
                    <h2 className='m-0 text-pretty text-[30px] font-medium leading-[1.15] tracking-[-1px] text-[#17130E] md:text-[40px]'>
                        {t('seoKeyword.shared.prices.title', 'Sin escribir ni un precio a mano')}
                    </h2>
                </div>

                {STEP_KEYS.map(stepKey => (
                    <div
                        key={stepKey}
                        className='grid grid-cols-[44px_1fr] gap-4 border-t border-[#E8E1D5] py-5 md:gap-5'
                    >
                        <div className='text-[28px] font-extrabold tabular-nums text-[#F4502A]'>
                            {String(Number(stepKey)).padStart(2, '0')}
                        </div>
                        <div className='flex flex-col gap-1'>
                            <div className='text-[17px] font-bold text-[#17130E] md:text-lg'>
                                {t(`seoKeyword.shared.prices.steps.${stepKey}.title`)}
                            </div>
                            <div className='text-sm leading-[1.55] text-[#5C5548] md:text-[15px] md:leading-relaxed'>
                                {t(`seoKeyword.shared.prices.steps.${stepKey}.description`)}
                            </div>
                        </div>
                    </div>
                ))}

                <div className='mt-5 flex flex-col gap-2.5 md:mt-7 md:grid md:grid-cols-2 md:gap-3'>
                    {BADGE_KEYS.map(badgeKey => (
                        <div
                            key={badgeKey}
                            className='flex items-center gap-2.5 rounded-[20px] bg-[#F7D9CC] px-4 py-3.5'
                        >
                            <Check className='size-[18px] shrink-0 text-[#F4502A]' strokeWidth={2.4} aria-hidden />
                            <div className='text-sm font-semibold text-[#17130E] md:text-[15px]'>
                                {t(`seoKeyword.shared.prices.badges.${badgeKey}`)}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
